import React, { useCallback, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import ToastComponent from "../Common/TaostComponent";

const HubCardDownload = (props) => {
  const modalContentRef = useRef(null);

  const captureImage = useCallback(() => {
    const modalContent = document.getElementById("playermoreinfo");
    if (modalContent) {
      html2canvas(modalContent, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.accountDetails?.username}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, [props.accountDetails?.username]);

  //   const handleModalEntered = useCallback(() => {
  //     const timeout = setTimeout(() => {
  //       captureImage();
  //       props.handleHubCardModalClose();
  //     }, 2000);
  //     return () => clearTimeout(timeout); // Cleanup the timeout
  //   }, [captureImage]);

  const { loadingStates, handleHubCardModalClose } = props;

  const handleModalEntered = useCallback(() => {
    if (loadingStates["hub_card"] === false) {
      captureImage();
      handleHubCardModalClose();
    }
  }, [loadingStates, captureImage, handleHubCardModalClose]);

  return (
    <>
      <Modal
        show={props.showAccountShareModal}
        onHide={() => props.setShowAccountShareModal(false)}
        size="lg"
        id="playermoreinfo"
        onEntered={handleModalEntered}
      >
        <div ref={modalContentRef}>
          <div className="gamevideo">
            <figure>
              <img src="/images/video-img.jpg" alt="img" />
            </figure>
          </div>
          <figure className="user-profile">
            {props.accountDetails && props.accountDetails?.club_logo && (
              <img
                src={`${process.env.REACT_APP_CLUB_PROFILE}${props.accountDetails?.club_logo}`}
                width="70"
                height="70"
                alt="img"
              />
            )}
            {!props.clubDetails ||
              (!props.clubDetails?.logo && (
                <img src="images/brand-logo.png" alt="img" />
              ))}
          </figure>
          <div className="profile-content">
            <h4>{props.accountDetails?.club_name}</h4>
            <div className="admindetail"></div>
            <QRCode
              value={`${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${props.accountDetails?.username}`} // The data or link the QR code will encode
              // size={256} // Size of the QR code
              renderAs="canvas" // Render the QR code as a canvas
              includeMargin={true} // Include margins around the QR code
            />

            <p>
              Invite members to join & play fantasy games on your Fantasy Hub!
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default HubCardDownload;
